import { reducer as formReducer } from "redux-form";
import userInfo from "./reducers/userInfo.js";
import popups from "./reducers/popups.js";
import customerInfo from "./reducers/customerInfo.js";
import userActions from "./reducers/userActions.js";
import ordersSell from "./reducers/ordersSell.js";
import paymentsSell from "./reducers/paymentsSell.js";
import orderAssistance from "./reducers/orderAssistance.js";
import { reducer as deductionsReducer } from "./modules/Deductions";
import { reducer as liabilitiesReducer } from "./modules/Liabilities";
import { reducer as cardsReducer } from "./modules/Cards";
import { reducer as dataComponentsReducer } from "./modules/DataComponents";
import { reducer as customerReducer } from "./modules/Customer";
import { reducer as localSecurityReducer } from "./modules/Security";
import { reducer as paymentMethodReducer } from "./modules/PaymentMethods";
import {
  merchantsReducer,
  merchantValidationReduer,
} from "./modules/Merchants";
import { reducer as CartReducer } from "./modules/Card/";
import { reducer as ssUploaderReducer } from "./modules/SSUploader";
import { reducer as magSensorReducer } from "./modules/MagSensor";

export const combineReducers = {
  userInfo,
  popups,
  customerInfo,
  userActions,
  ordersSell,
  paymentsSell,
  orderAssistance,
  form: formReducer,
  deductions: deductionsReducer,
  liabilities: liabilitiesReducer,
  cards2: cardsReducer,
  dataComponents: dataComponentsReducer,
  localSecurity: localSecurityReducer,
  customer: customerReducer,
  paymentMethods: paymentMethodReducer,
  merchants: merchantsReducer,
  Cart: CartReducer,
  merchantValidation: merchantValidationReduer,
  ssUploader: ssUploaderReducer,
  magSensor: magSensorReducer,
};
